import { useBrand } from '../context/BrandContext';
import FastestFormChatbotList from './fastestform/ChatbotList';
import AbleChatbotList from './able/ChatbotList';

export default function ChatbotList() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleChatbotList /> : <FastestFormChatbotList />;
}
